import * as React from "react";
import { connect } from "react-redux";
import * as toastr from "toastr";

import { IState } from "../../classes/state";
import { IText } from "../../classes/text";

export interface IYearAndMonthPickerProps {
  currentDate: Date;
  monthNamesComplete: string[];
  monthNamesAbbreviated: string[];
  numAjaxCallsInProgress: number;
  text: IText;
  onSetCurrentYear: (event: any) => any;
  onSetCurrentMonth: (event: any) => any;
}

export const YearAndMonthPicker = (props: IYearAndMonthPickerProps) => {

  const curDate = new Date(props.currentDate);
  const year = curDate.getFullYear();
  const monthNumber = curDate.getMonth();
  const monthFullname = props.monthNamesComplete[monthNumber];

  let setCurrentMonth = props.onSetCurrentMonth;
  let setCurrentYear = props.onSetCurrentYear;
  if (props.numAjaxCallsInProgress > 0) {
    setCurrentMonth = null;
    setCurrentYear = null;
  }

  const monthLinks: JSX.Element[] = [];
  let cssClasses = "";
  let activeClass = "";
  for (let m = 0; m < 12; m++) {
    m === monthNumber ? activeClass = "CAL-active " : activeClass = "";
    cssClasses = "CAL-button " + activeClass + "js-nav-system__subnav__link";
    if (props.numAjaxCallsInProgress > 0) { cssClasses += " disabled"; }
    monthLinks.push(
      <li className="js-nav-system__subnav__item CAL-DD-monthButton" key={m}><a className={cssClasses} onClick={setCurrentMonth} href="#!" data-month-number={m} tabIndex={-1}>{props.monthNamesAbbreviated[m]}</a></li>,
    );
  }

  let yearAnchorClass = "CAL-button CAL-square js-nav-system__subnav__link";
  if (props.numAjaxCallsInProgress > 0) { yearAnchorClass += " disabled"; }

  return (
    <ul className="js-nav-system">
      <li className="CLA-dropdownWrapper js-nav-system__item">
        <a className="CAL-dropdownButton CAL-monthSelector js-nav-system__link" href="#!" data-tooltip={props.text.mainToolbar.useArrowKeysToNavigateThroughOptions}>{monthFullname} <span className="CAL-currentYear">{year}</span> <em className="fa fa-sort" aria-hidden="true"></em></a>
         <div className="CAL-dropdown CAL-DD-monthSelect js-nav-system__subnav">
          <span className="triangle" aria-hidden="true"></span>
          <ul>
            <li>
              <ul className="CAL-DD-monthGrid">
                {monthLinks}
                <li className="js-nav-system__subnav__item CAL-DD-year-button CAL-DD-year-prev"><a onClick={setCurrentYear} data-year={year - 1} className={yearAnchorClass} href="#!" title={props.text.mainToolbar.previousYear} tabIndex={-1}><em className="fa fa-arrow-left" aria-hidden="true"></em><span className="offScreen">{props.text.mainToolbar.previousYear}</span></a></li>
                <li className="js-nav-system__subnav__item CAL-DD-year-button CAL-DD-year-next"><a onClick={setCurrentYear} data-year={year + 1} className={yearAnchorClass} href="#!" title={props.text.mainToolbar.nextYear} tabIndex={-1}><em className="fa fa-arrow-right" aria-hidden="true"></em><span className="offScreen">{props.text.mainToolbar.nextYear}</span></a></li>
              </ul>
            </li>
            <li>
              <div className="CAL-DD-yearPick">
                <ul>
                  <li className="CAL-DDYP-year"><span className="offScreen">{props.text.mainToolbar.currentlyShowing}</span>{year}</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  );
};
